export enum NowLocation {
	InRange = 'in-range',
	Before = 'before',
	After = 'after',
}
